import React from 'react'
import {Navigate, Outlet } from 'react-router-dom';
import Header from '../components/Header';

function LayoutWithHeader() {
    const isLoggedIn = localStorage.getItem('isLoggedIn')
  return (
    <div>  
    {isLoggedIn ? <>
        <Header />
        <Outlet /> </> : 
       <Navigate to="/prelogin"  replace />}
    </div>
  )
}

export default LayoutWithHeader